import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild } from "@angular/core";
import { ItineraryService } from "../shared/itinerary.service";
import { Observable, Subject } from "../../../node_modules/rxjs";
import { RestService } from "../shared/rest.service";
import { UserService } from "../pages/com.usblick.common/auth/user.service";
import { setting } from "../../../setting";
import { YourtripSummaryComponent } from "./content-summary/yourtrip-summary/yourtrip-summary.component";
import { Store } from "@ngrx/store";
import { AppState } from "app/core/profiles/storeProfile";
import { selectPermissions } from "app/core/profiles/profiles.selectors";
import { takeUntil } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

@Component({
  selector: "usb-itinerary-summary",
  templateUrl: "./itinerary-summary.component.html",
  styleUrls: ["./itinerary-summary.component.scss"],
})
export class ItinerarySummaryComponent implements OnInit {
  @ViewChild(YourtripSummaryComponent)
  yourTripSummaryComponent!: YourtripSummaryComponent;
  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};
  _actualItinerary: any;
  _flightInfo: any;
  suggestions: any;
  partialReserve: boolean;
  qtyItemsToPartial: number = 0;
  cargoSugg = false;
  itinerary$: Observable<any[]>;
  public getClientsSettingAppBooking: any;
  public sectionSummary: any;
  public routeUploadFile: any;
  currencies: any[] = [];
  currencyAgency: any;
  netPriceAgent: number = 0;
  summaryItinerary: any[] = [];
  appLoading: boolean = true;
  reloadItinerary: boolean = false;
  routerStorage: any;
  suggestionsItineraryNoData: boolean = false;
  // Para guardar sugerencias de getSuggestionsByDate y aplicarlas después en parsePeriods
  pendingSuggestionsByDate: any = null;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _itineraryService: ItineraryService,
    private restService: RestService,
    public userService: UserService,
    private store: Store<AppState>,
    private router: Router,
    public toastr: ToastrService
  ) {

  }

  ngOnInit() {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.routerStorage = setting.apiStorageBooking;
    this.currencies = this.userService?.currenciesExchange;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.currencyAgency = this.currencies?.find(c => c.code === selectedAgency.currency);

    if(!this.currencyAgency) {
      this.router.navigateByUrl('home');
      this.toastr.warning('Moneda no configurada en la agencia');
    }
    this.routeUploadFile = setting.routeUploadFile;
    this.sectionSummary = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_summary);
    this.getPermissions();
    this._initData();
  }

  /**
   * Método para obtener los permisos desde el store y actualizar el mapa de permisos.
   *
   * Este método obtiene los permisos a través de un selector del store y suscribe a los cambios.
   * Los permisos obtenidos son procesados y almacenados en un mapa para un acceso más fácil.
   *
   * @permissions$-> Observable que contiene los permisos.
   * @permissionsMap-> Mapa donde los permisos son almacenados usando el nombre del permiso como clave.
   */
  getPermissions(): void {
    this.permissions$ = this.store.select(selectPermissions);
    this.permissions$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });
  }

  /**
  * Método para crear un mapa de permisos desde un arreglo de permisos.
  *
  * Este método toma un arreglo de permisos y genera un objeto donde la clave es el nombre del permiso
  * y el valor es el objeto del permiso correspondiente.
  *
  * @permissions-> Arreglo de permisos obtenidos desde el store.
  * @returns-> Un objeto (mapa) con los permisos donde las claves son los nombres de los permisos.
  */
  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      // Utiliza el nombre del permiso como clave
      map[permission.name] = permission;
    });
    return map;
  }


/**
 * Inicializa los datos del itinerario activo
 *
 * Este método intenta obtener el itinerario activo desde el servicio de usuario.
 * Si no hay itinerario localmente, se suscribe al observable del servicio de itinerarios.
 *
 * @actualItinerary {any} - Objeto que representa el itinerario actualmente activo.
 * @subscription {Observable<any>} - Suscripción al observable que emite el itinerario activo.
 */
  _initData() {
  if (this.userService.itineraryActive.length > 0) {
    var data = this.userService.itineraryActive;
    if (data) {
      if (data[0]) {

        this._actualItinerary = data[0];
        this._initFlights();
        this.getTotalTarifa();
        this.getItinerarySummary();
        // this.getSuggestionsBig();
      } else {
        this._actualItinerary = null;
      }
    }
  }

  // Siempre suscribirse para recibir updates posteriores (post-add/delete).
  // Esto se activa cuando updateItinerary() completa → consultActiveItinerary()
  // → sendMessageActiveItinerary() → activeItinerary emite datos frescos del backend.
  let suscription = (this._itineraryService.activeItinerary as Observable<any>).subscribe(
    (data: any) => {
      if (data) {
        if (data[0]) {
          this._actualItinerary = data[0];
          this._initFlights();
          this.getTotalTarifa();
          this.getItinerarySummary();
          // this.getSuggestionsBig();
        } else {
          this._actualItinerary = null;
        }
      }
    },
    (error) => {
      console.log("Error: ", error);
    }
  );
}

/**
 * Inicializa la información de vuelos del itinerario
 *
 * Este método obtiene la información de vuelo para el itinerario actual mediante una
 * solicitud al endpoint `itinerary/{id}/fly`. Los datos de vuelo se almacenan en
 * `this._flightInfo`.
 *
 * @url {string} - Endpoint que obtiene los datos de vuelos del itinerario.
 * @flight {any} - Primer objeto de vuelo devuelto por la respuesta del backend.
 * @flightInfo {object} - Objeto con datos detallados del vuelo (fechas, aerolíneas, números, etc.).
 * @error {HttpErrorResponse} - Objeto de error en caso de fallo en la solicitud HTTP.
 */
_initFlights() {
  if (this._actualItinerary["id"] && this._actualItinerary["id"].length > 0) {
    const url = "itinerary/" + this._actualItinerary["id"] + "/fly";
    this._itineraryService._restService.doGet("app", url).subscribe({
      next: (response: any) => {
        if (response["data"] && response["data"][0]) {
          const flight = response["data"][0];
          this._flightInfo = {
            departureIn: new Date(flight["departureIn"]),
            arrivalIn: new Date(flight["arrivalIn"]),
            airportIn: flight["airportIn"],
            airlineIn: flight["airlineIn"],
            flyNumberIn: flight["flyNumberIn"],
            departureOut: new Date(flight["departureOut"]),
            arrivalOut: new Date(flight["arrivalOut"]),
            airportOut: flight["airportOut"],
            airlineOut: flight["airlineOut"],
            flyNumberOut: flight["flyNumberOut"],
          };
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log("Has no flights associated", error);
      }
    });
  }
}


/**
 * Obtiene las sugerencias asociadas al itinerario actual
 *
 * Este método llama al endpoint `suggestionsByID/{id}` para recuperar sugerencias
 * y las asigna a la variable `this.suggestions`.
 *
 * @url {string} - Endpoint construido con el ID del itinerario actual.
 * @suggestions {any[]} - Arreglo con las sugerencias obtenidas del backend.
 * @response {any} - Objeto de respuesta que contiene las sugerencias.
 * @error {HttpErrorResponse} - Objeto que representa un error de respuesta HTTP.
 */
getSuggestionsBig() {
  const url = "suggestionsByID/" + this._actualItinerary.id;
  this.restService.doGet("app", url).subscribe({
    next: (data: any) => {
      this.suggestions = data.suggestions;
    },
    error: (error: HttpErrorResponse) => {
      console.log("error response", error);
    }
  });
}

/**
 * Establece la cantidad de ítems para reserva parcial
 *
 * Este método asigna un número determinado a la variable `qtyItemsToPartial`,
 * usada para gestionar reservas parciales.
 *
 * @param qty {number} - Cantidad de ítems seleccionados para reserva parcial.
 */
_itemToPartial(qty: number) {
  this.qtyItemsToPartial = qty;
}

/**
 * Navega al componente de resumen para continuar con la reserva
 *
 * Este método delega la acción al componente `YourTripSummaryComponent` para
 * proceder con la reserva desde el resumen del viaje.
 */
goReserveFee() {
  this.yourTripSummaryComponent.goToReserve();
}

         getTotalTarifa() {
            let price = 0;
            //  price = this.itinerary.totalNetPriceAgent ? this.itinerary.totalNetPriceAgent  : 0;

            price = this.calculateTotal('netPriceAgent');
            this.netPriceAgent = price;
          }


private calculateTotal(fieldName: string): number {

  return this._itineraryService.calculateTotal(
                                                fieldName,
                                                this._actualItinerary,
                                                this.currencies,
                                                this.currencyAgency);
}

getItinerarySummary(): void {
  this.restService.doGet('app', 'summaryItinerary/'+this._actualItinerary.id, { params: { hide_flights: true } }).subscribe({
    next: (res: any) => {
      if(res && res.length > 0) {
        this.summaryItinerary = [];
        this.pendingSuggestionsByDate = null; // Limpiar sugerencias pendientes
        this.buildSummaryFromBackend(res);
        // Llamar DESPUÉS de buildSummaryFromBackend para que summaryItinerary ya esté listo
        // Se usa suggestions-by-date como única fuente de sugerencias para el timeline
        this.getSuggestionsByDate();
      }
    },
  });
}

/**
 * Punto de entrada unificado para construir el summaryItinerary a partir del backend.
 *
 * Responsabilidades (en orden):
 *  1. Agrupar destinos con el mismo iata_code (combinar BUE hoteles + BUE transfers).
 *  2. Extraer seguros de destinos solo-seguros ANTES de descartarlos.
 *  3. Generar los días intermedios considerando TANTO las actividades de cada destino
 *     COMO los rangos de fechas de los seguros extraídos (fix del bug donde
 *     un seguro del 1-4 de julio no generaba días intermedios si los hoteles
 *     estaban del 17-20 de junio).
 *  4. Procesar parsedPeriods y marcar _insurancesActive/_insurancesEnded en
 *     los días correctos.
 */
private buildSummaryFromBackend(res: any[]): void {
  const groupedData = this.groupDestinationsByIata(res);
  const { filtered, extractedInsurances } = this.extractAndFilterInsuranceDestinations(groupedData);
  this.parsePeriods(filtered, extractedInsurances);
}

getSuggestionsItineraryIA(): void {
  const url: string = `itineraries/suggestions/${this._actualItinerary.id}`;
  this.restService.doGet('app', url).subscribe({
    next: (res: any) => {
      const hasData = res.data && Object.keys(res.data).length > 0;
      return;

      if(res.cod === 200 && res.res === 1 && hasData) {
        this.addSuggestionsToActivities(this.summaryItinerary, res.data);
        this.addSuggestionsToParsedPeriods(this.summaryItinerary, res.data);
      } else {
        this.suggestionsItineraryNoData = true;
      }

      // Siempre obtener sugerencias por fecha para rellenar días intermedios
      // TODO: Deshabilitado temporalmente - la inyección de sugerencias intermedias tiene problemas
      this.getSuggestionsByDate();
    }
  })
}

/**
 * Obtiene sugerencias por fecha para el itinerario actual
 * Endpoint: /itineraries/suggestions-by-date/{itineraryId}
 *
 * Única fuente de sugerencias para el timeline.
 * Los loaders se mantienen visibles hasta que haya sugerencias reales por día.
 */
getSuggestionsByDate(): void {
  const url: string = `itineraries/suggestions-by-date/${this._actualItinerary.id}`;
  this.restService.doGet('app', url).subscribe({
    next: (res: any) => {
      if (res.cod === 200 && res.data) {
          this.injectSuggestionsIntoExistingDays(res.data);
      }
      // Si no hay datos: los loaders se quedan visibles (permanentes)
      // hasta que haya sugerencias reales para cada día
    },
    error: (error: any) => {
      console.log('[getSuggestionsByDate] Error:', error);
      // En error: los loaders se quedan visibles (permanentes)
    }
  });
}

  /**
   * Inyecta sugerencias por fecha en TODOS los días del itinerario.
   * Tanto días intermedios generados como días con actividades reales.
   */
  injectSuggestionsIntoExistingDays(suggestionsByDate: { [date: string]: any[] }): void {
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    this.summaryItinerary.forEach(destination => {
      const days = destination.days || [];

      days.forEach((day: any) => {
        if (!day.full_date) return;

        // TODO: Si en el futuro se requieren sugerencias en días de checkout/transfer-out,
        // eliminar esta condición. Por ahora no se muestran sugerencias esos días
        // ya que el huésped está por partir y no tiene sentido sugerir actividades.
        if (day._isCheckoutDay) return;

        const suggestions = suggestionsByDate[day.full_date];
        if (suggestions && suggestions.length > 0) {
          day.dateSuggestions = suggestions;
        }
      });
    });
  }

  /**
   * Inyecta días intermedios con sugerencias en summaryItinerary
   * para fechas que no tienen día pero tienen sugerencias.
   *
   * Filtra sugerencias por destino usando el rango de fechas de los días existentes.
   * Una sugerencia de fecha X se asigna al destino cuyo rango de días la contiene.
   */
  injectIntermediateDays(suggestionsGroupedByDate: { [date: string]: any[] }): void {
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    this.summaryItinerary.forEach(destination => {
      let existingDays = destination.days || [];
      if (existingDays.length === 0) return;

      // Prevenir duplicados: remover días intermedios inyectados previamente
      existingDays = existingDays.filter((d: any) => !d._isIntermediateInjected);
      destination.days = existingDays;

      // Calcular rango de fechas usando solo días originales (no intermedios)
      const originalDates = existingDays
        .filter((d: any) => !d._isIntermediateInjected)
        .map((d: any) => d.full_date)
        .filter((d: any) => d)
        .sort((a: any, b: any) => new Date(a).getTime() - new Date(b).getTime());

      if (originalDates.length === 0) return;

      const minDate = new Date(originalDates[0]);
      const maxDate = new Date(originalDates[originalDates.length - 1]);

      // Normalizar maxDate al final del día para incluir el último día
      maxDate.setHours(23, 59, 59, 999);

      const existingDateSet = new Set(existingDays.map((d: any) => d.full_date));

      Object.keys(suggestionsGroupedByDate).forEach(dateKey => {
        const suggestions = suggestionsGroupedByDate[dateKey];
        if (!suggestions || suggestions.length === 0) return;
        if (existingDateSet.has(dateKey)) return; // Ya existe el día

        // Solo asignar la sugerencia si la fecha cae dentro del rango de este destino
        const sugDate = new Date(dateKey);
        if (sugDate < minDate || sugDate > maxDate) return;

        // Crear día intermedio solo con sugerencias (sin actividades)
        const intermediateDay = {
          full_date: dateKey,
          date: this.formatDateShort(dateKey),
          day_title: '', // Se renumera abajo
          has_airport_transfer: false,
          activities: { morning: [], afternoon: [], night: [] },
          parsedPeriods: [], // Vacío para que NO entre en el bloque de actividades del template
          intermediateSuggestions: suggestions,
          _isIntermediateInjected: true // Marca para prevenir duplicados
        };

        // Insertar en la posición correcta según la fecha
        const insertIndex = existingDays.findIndex((d: any) => {
          const dayDate = new Date(d.full_date);
          return sugDate < dayDate;
        });

        if (insertIndex === -1) {
          existingDays.push(intermediateDay);
        } else {
          existingDays.splice(insertIndex, 0, intermediateDay);
        }
      });

      // Ordenar los días por full_date
      destination.days?.sort((a: any, b: any) => {
        return new Date(a.full_date).getTime() - new Date(b.full_date).getTime();
      });

      // Numerar solo los días intermedios inyectados, sin modificar los originales del backend
      const allDays = destination.days || [];
      allDays.forEach((day: any, index: number) => {
        if (day._isIntermediateInjected) {
          // Buscar el día original anterior para obtener el número base
          let prevOriginalNumber = 0;
          for (let i = index - 1; i >= 0; i--) {
            if (!allDays[i]._isIntermediateInjected && allDays[i].day_title) {
              const match = allDays[i].day_title.match(/Dia\s+(\d+)/i);
              if (match) {
                prevOriginalNumber = parseInt(match[1], 10);
              }
              break;
            }
          }
          // Contar cuántos intermedios hay antes de este (desde el último original)
          let intermediateOffset = 0;
          for (let i = index - 1; i >= 0; i--) {
            if (allDays[i]._isIntermediateInjected) {
              intermediateOffset++;
            } else {
              break;
            }
          }
          const dayNumber = prevOriginalNumber + intermediateOffset + 1;
          day.day_title = `Dia ${dayNumber} - ${destination.city_name}`;
        }
      });
    });
  }

/**
 * @deprecated Esta función fue reemplazada por injectIntermediateDays().
 * La lógica de inyección de días intermedios y asignación de sugerencias
 * por fecha ahora vive exclusivamente en injectIntermediateDays() y
 * addSuggestionsToParsedPeriods() respectivamente.
 */

  private formatDateShort(dateStr: string): string {
  // Parse date parts directly to avoid timezone offset issue:
  // new Date("2026-06-02") is parsed as UTC midnight, which in UTC-3
  // becomes June 1st at 21:00 local time, returning the WRONG date.
  const parts = dateStr.split('-');
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day} ${monthNames[month - 1]}.`;
}

  /**
   * Genera días intermedios vacíos entre las fechas del primer y último día de cada destino.
   * Los días intermedios que caen dentro del rango de estadía de un hotel reciben
   * metadata de desayuno (_breakfastInfo) para mostrar un texto simple verde/rojo.
   * Los días sin servicios ni hotel se marcan como isFreeDay en parsePeriods().
   */
  private fillMissingDays(data: any[], insurances?: { activity: any; startDate: string; endDate: string }[]): any[] {
    return data.map((destination: any) => {
      const existingDays = destination.days || [];
      if (existingDays.length === 0) return destination;

      // Obtener fechas ordenadas de días existentes
      const sortedDates = existingDays
        .map((d: any) => d.full_date)
        .filter((d: any) => d)
        .sort();

      if (sortedDates.length === 0) return destination;

      let startDateStr = sortedDates[0];
      let endDateStr = sortedDates[sortedDates.length - 1];

      // Extender el rango con las fechas de las actividades (hotels, transfers, etc.)
      // Esto permite generar días intermedios para CUALQUIER categoría que abarque múltiples días
      // (ej: hotel check-in Jun 1, checkout Jun 12 → genera días Jun 1 a Jun 12)
      const activityRange = this.extractActivityDateRanges(existingDays);
      if (activityRange.minDate && activityRange.minDate < startDateStr) {
        startDateStr = activityRange.minDate;
      }
      if (activityRange.maxDate && activityRange.maxDate > endDateStr) {
        endDateStr = activityRange.maxDate;
      }

      // Extender el rango también con los rangos de los seguros extraídos.
      // Esto resuelve el caso donde un seguro está en fechas que NO están en
      // los días del destino (ej: hotel del 17-20 jun + seguro del 1-4 jul).
      // Sin esto, el destino no generaba días para las fechas del seguro y por
      // tanto no podía mostrar el marcador de "seguro activo" en el día correcto.
      if (insurances && insurances.length > 0) {
        for (const ins of insurances) {
          const insStart = this.normalizeDateToYYYYMMDD(ins.startDate);
          const insEnd = this.normalizeDateToYYYYMMDD(ins.endDate);
          if (insStart && insStart < startDateStr) startDateStr = insStart;
          if (insEnd && insEnd > endDateStr) endDateStr = insEnd;
        }
      }

      // Si el rango resultante es de un solo día, solo corregir el day_title
      // (el backend puede mandar "Dia 4 - Origen" y necesitamos "Dia 1 - Ciudad")
      if (startDateStr === endDateStr) {
        const dayIndex = existingDays.findIndex((d: any) => d.full_date === startDateStr);
        if (dayIndex !== -1) {
          existingDays[dayIndex].day_title = `Dia 1 - ${destination.city_name}`;
        }
        return {
          ...destination,
          days: existingDays
        };
      }

      // Crear mapa de días existentes por fecha
      const daysByDate = new Map<string, any>();
      existingDays.forEach((d: any) => {
        if (d.full_date) daysByDate.set(d.full_date, d);
      });

      // --- Encontrar hoteles y sus rangos de estadía (stay) ---
      // Ahora extraemos también info de desayuno y nombre de habitación
      const hotelStayRanges: {
        startDate: string;
        endDate: string;
        hotelName: string;
        rooms: { name: string; hasBreakfast: boolean }[];
        hasAnyBreakfast: boolean;
        checkoutTime: string;
      }[] = [];
      existingDays.forEach((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;
        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            if (act?.activity?.categoryName === 'HOTELS') {
              try {
                const activityData = typeof act.activity.item === 'string'
                  ? JSON.parse(act.activity.item)
                  : act.activity.item;

                if (activityData?.stay?.startDate && activityData?.stay?.endDate) {
                  // Solo agregar si no existe ya un rango para este hotel en estas fechas
                  const existingRange = hotelStayRanges.find(h =>
                    h.startDate === activityData.stay.startDate &&
                    h.endDate === activityData.stay.endDate &&
                    h.hotelName === act.activity.title
                  );

                  if (!existingRange) {
                    // Evaluar desayuno basado en boardName del item parseado (misma lógica que hasBreakfast en item-hotel)
                    const boardName = (activityData?.boardName || activityData?.room?.boardName || '').toUpperCase();
                    const hasBreakfast = boardName.includes('BREAKFAST') || boardName.includes('HALF BOARD') || boardName.includes('FULL BOARD') || boardName.includes('CON DESAYUNO');
                    const item = JSON.parse(act.activity.item);
                    const timeCheckout = item.hotelAdditionalInfo.length ? item.hotelAdditionalInfo[0].TimeInformation.checkOut : '-';

                    hotelStayRanges.push({
                      startDate: activityData.stay.startDate,
                      endDate: activityData.stay.endDate,
                      hotelName: act.activity.title || item.title || '',
                      checkoutTime: timeCheckout,
                      rooms: [{
                        name: act.activity.room?.name || act.activity.room?.description || boardName || 'Habitación',
                        hasBreakfast: hasBreakfast
                      }],
                      hasAnyBreakfast: hasBreakfast
                    });
                  } else {
                    // Hotel agrupado: agregar rooms adicionales
                    const boardName = (activityData?.boardName || activityData?.room?.boardName || '').toUpperCase();
                    const hasBreakfast = boardName.includes('BREAKFAST') || boardName.includes('HALF BOARD') || boardName.includes('FULL BOARD');
                    existingRange.rooms.push({
                      name: act.activity.room?.name || act.activity.room?.description || boardName || 'Habitación',
                      hasBreakfast: hasBreakfast
                    });
                    if (hasBreakfast) {
                      existingRange.hasAnyBreakfast = true;
                    }
                  }
                }
              } catch (e) {
                console.warn('[fillMissingDays] Error parsing hotel item:', e);
              }
            }
          });
        });
      });

      // Generar todas las fechas en el rango
      const allDays: any[] = [];
      let currentDateStr = startDateStr;

      while (currentDateStr <= endDateStr) {
        if (daysByDate.has(currentDateStr)) {
          // Día existente del backend
          allDays.push(daysByDate.get(currentDateStr));
        } else {
          // Día intermedio: buscar si cae dentro de la estadía de algún hotel
          const matchingHotels = hotelStayRanges.filter(hotel =>
            currentDateStr >= hotel.startDate && currentDateStr < hotel.endDate
          );

          // Verificar si es un día de checkout (stay.endDate) de alguno de los hoteles
          // Esto se evalúa SIEMPRE, incluso si también es día de check-in de otro hotel
          const checkoutHotels = hotelStayRanges.filter(hotel => hotel.endDate === currentDateStr);

          let breakfastInfo: any = null;
          let checkoutHotelInfo: any = null;
          if (matchingHotels.length > 0) {
            // Usar el primer hotel que tenga estadía en esta fecha
            const hotel = matchingHotels[0];
            // Buscar la primera habitación con desayuno para el mensaje
            const roomWithBreakfast = hotel.rooms.find((r: any) => r.hasBreakfast);
            breakfastInfo = {
              hotelName: hotel.hotelName,
              roomName: roomWithBreakfast?.name || hotel.rooms[0]?.name || '',
              hasBreakfast: hotel.hasAnyBreakfast
            };
          }

          // ¿Es el día de checkout (stay.endDate)?
          // Usar el hotel que NO está en matchingHotels (el que termina ese día)
          if (checkoutHotels.length > 0) {
            // Preferir el hotel que NO es check-in de otro rango overlapping
            const checkoutHotel = checkoutHotels.find(h =>
              !matchingHotels.some(m => m.hotelName === h.hotelName && m.startDate === h.startDate)
            ) || checkoutHotels[0];

            checkoutHotelInfo = {
              title: checkoutHotel.hotelName,
              time: checkoutHotel.checkoutTime
            };
          }

          allDays.push({
            full_date: currentDateStr,
            date: this.formatDateShort(currentDateStr),
            day_title: '', // Se renumera abajo
            has_airport_transfer: false,
            activities: { morning: [], afternoon: [], night: [] },
            _isGenerated: true,
            _breakfastInfo: breakfastInfo,
            _isCheckoutDay: !!checkoutHotelInfo,
            _checkoutHotelInfo: checkoutHotelInfo
          });
        }
        currentDateStr = this.addDaysToDate(currentDateStr, 1);
      }

      // Renumera todos los días del destino de forma secuencial
      allDays.forEach((day: any, index: number) => {
        day.day_title = `Dia ${index + 1} - ${destination.city_name}`;
      });

      return {
        ...destination,
        days: allDays
      };
    });
  }

  /**
   * Agrupa destinos con el mismo iata_code en un solo destino, fusionando sus días.
   * Evita duplicados de días por full_date (mantiene el primero encontrado).
   *
   * TODO: Esta agrupación debería hacerse del lado del backend en el futuro.
   * Extrae seguros de destinos solo-seguros y filtra esos destinos del array.
   * Los seguros extraídos se pasan a parsePeriods para inyectarlos como marcadores
   * en los días correspondientes de los destinos reales.
   *
   * TODO: Por ahora los seguros se inyectan en TODOS los destinos que tengan un día
   * con la misma fecha. Cuando el backend envíe un dato para asociar seguros a un
   * destino específico, usar ese dato para casarlos correctamente.
   */
  private extractAndFilterInsuranceDestinations(destinations: any[]): {
    filtered: any[];
    extractedInsurances: { activity: any; startDate: string; endDate: string }[];
  } {
    const extractedInsurances: { activity: any; startDate: string; endDate: string }[] = [];

    const filtered = destinations.filter((destination: any) => {
      const hasNonInsuranceActivity = (destination.days || []).some((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return false;
        return ['morning', 'afternoon', 'night'].some(p =>
          Array.isArray(periods[p]) && periods[p].some((act: any) =>
            act?.activity?.category_id !== 10 && act?.activity?.categoryName !== 'INSURANCE'
          )
        );
      });

      if (!hasNonInsuranceActivity) {
        // Destino solo-seguros: extraer los seguros antes de descartarlo
        (destination.days || []).forEach((day: any) => {
          const periods = day.activities;
          if (!periods || typeof periods !== 'object') return;
          ['morning', 'afternoon', 'night'].forEach(period => {
            if (!Array.isArray(periods[period])) return;
            periods[period].forEach((act: any) => {
              if (act?.activity?.category_id === 10 || act?.activity?.categoryName === 'INSURANCE') {
                try {
                  const item = typeof act.activity.item === 'string'
                    ? JSON.parse(act.activity.item)
                    : act.activity.item;

                  // Priorizar payload.dateBegin/dateEnd (fechas correctas sin timezone)
                  // form.beginDateEndDate tiene timezone que puede dar fecha incorrecta
                  // (ej: end "2026-06-07T03:59:59Z" es en realidad 06-06 en UTC-3)
                  const startDate = item?.payload?.dateBegin
                    || act.activity.arrivalDate
                    || (item?.form?.beginDateEndDate?.start
                      ? item.form.beginDateEndDate.start.split('T')[0]
                      : null);

                  const endDate = item?.payload?.dateEnd
                    || act.activity.departureDate
                    || (item?.form?.beginDateEndDate?.end
                      ? item.form.beginDateEndDate.end.split('T')[0]
                      : null);

                  if (startDate && endDate) {
                    extractedInsurances.push({
                      activity: act.activity,
                      startDate,
                      endDate
                    });
                  }
                } catch (e) {
                  if (act.activity.arrivalDate && act.activity.departureDate) {
                    extractedInsurances.push({
                      activity: act.activity,
                      startDate: act.activity.arrivalDate,
                      endDate: act.activity.departureDate
                    });
                  }
                }
              }
            });
          });
        });
        return false; // Eliminar destino solo-seguros
      }

      return true;
    });

    return { filtered, extractedInsurances };
  }

  /**
   * Agrupa destinos con el mismo iata_code en un solo destino, fusionando sus días.
   * Evita duplicados de días por full_date (mantiene el primero encontrado).
   *
   * TODO: Esta agrupación debería hacerse del lado del backend en el futuro.
   * Por ahora se resuelve en el frontend para combinar destinos de la misma ciudad
   * (ej: BUE hoteles 01-06 Jun + BUE transfers 08-23 Jun → un solo destino BUE 01-23 Jun).
   */
  private groupDestinationsByIata(destinations: any[]): any[] {
    if (!destinations || destinations.length === 0) return destinations;

    const groupedMap = new Map<string, any>();

    destinations.forEach((dest: any) => {
      const iata = dest.iata_code;
      if (!iata) return; // Skip destinos sin iata_code

      if (!groupedMap.has(iata)) {
        // Primer destino con este iata_code: usar como base
        groupedMap.set(iata, {
          ...dest,
          days: [...(dest.days || [])]
        });
      } else {
        // Destino duplicado: fusionar días
        const existing = groupedMap.get(iata)!;
        const existingDates = new Set(
          (existing.days || []).map((d: any) => d.full_date).filter(Boolean)
        );

        (dest.days || []).forEach((day: any) => {
          // Solo agregar días que no existan ya (evitar duplicados por fecha)
          if (day.full_date && !existingDates.has(day.full_date)) {
            existing.days.push(day);
            existingDates.add(day.full_date);
          }
        });
      }
    });

    // Ordenar los días de cada destino agrupado por full_date
    groupedMap.forEach((dest: any) => {
      if (dest.days && dest.days.length > 0) {
        dest.days.sort((a: any, b: any) => {
          if (!a.full_date || !b.full_date) return 0;
          return a.full_date.localeCompare(b.full_date);
        });
      }
    });

    return Array.from(groupedMap.values());
  }

  /**
   * Suma N días a una fecha en formato YYYY-MM-DD evitando problemas de timezone.
   */
  private addDaysToDate(dateStr: string, days: number): string {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  /**
   * Extrae los rangos de fechas (arrivalDate/departureDate) de TODAS las actividades
   * en los días dados, independientemente de la categoría.
   * Retorna la fecha mínima (arrivalDate más temprana) y máxima (departureDate más tardía).
   * Se usa para extender el rango de días intermedios más allá de los días existentes del backend.
   *
   * Esto permite que hoteles, transfers, o cualquier categoría con rango de fechas
   * generen automáticamente los días intermedios correspondientes.
   */
  private extractActivityDateRanges(days: any[]): { minDate: string | null; maxDate: string | null } {
    let minDate: string | null = null;
    let maxDate: string | null = null;

    days.forEach((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return;

      ['morning', 'afternoon', 'night'].forEach(period => {
        if (!Array.isArray(periods[period])) return;
        periods[period].forEach((act: any) => {
          const activity = act?.activity;
          if (!activity) return;

          try {
            // Parsear item JSON — arrivalDate/departureDate viven dentro del item string
            const item = typeof activity.item === 'string'
              ? JSON.parse(activity.item)
              : activity.item;

            if (!item) return;

            // Para seguros (INSURANCE): las fechas están en payload.dateBegin/dateEnd o en
            // form.beginDateEndDate (start/end). Si no las encontramos, caemos al fallback
            // de arrivalDate/departureDate del activity.
            const isInsurance = activity.category_id === 10 || activity.categoryName === 'INSURANCE';

            let startDate: string | null = null;
            let endDate: string | null = null;

            if (isInsurance) {
              startDate = item?.payload?.dateBegin
                || activity.arrivalDate
                || (item?.form?.beginDateEndDate?.start
                  ? item.form.beginDateEndDate.start.split('T')[0]
                  : null);
              endDate = item?.payload?.dateEnd
                || activity.departureDate
                || (item?.form?.beginDateEndDate?.end
                  ? item.form.beginDateEndDate.end.split('T')[0]
                  : null);
            } else {
              // Para hoteles: stay.startDate/stay.endDate son los más precisos
              // Para otras categorías: arrivalDate/departureDate del item parseado
              if (item.stay?.startDate) {
                startDate = this.normalizeDateToYYYYMMDD(item.stay.startDate);
              } else if (item.arrivalDate) {
                startDate = this.normalizeDateToYYYYMMDD(item.arrivalDate);
              }

              if (item.stay?.endDate) {
                endDate = this.normalizeDateToYYYYMMDD(item.stay.endDate);
              } else if (item.departureDate) {
                endDate = this.normalizeDateToYYYYMMDD(item.departureDate);
              }
            }

            if (startDate && (!minDate || startDate < minDate)) {
              minDate = startDate;
            }
            if (endDate && (!maxDate || endDate > maxDate)) {
              maxDate = endDate;
            }
          } catch (e) {
            // Si falla el parse del item, ignorar esta actividad
          }
        });
      });
    });

    return { minDate, maxDate };
  }

addSuggestionsToActivities(activitiesArray: any[], suggestionsData: any): void {
  if (!activitiesArray || !suggestionsData) {
    console.error('❌ Faltan datos para procesar sugerencias');
    return;
  }

  let totalActivities = 0;
  let suggestionsAssigned = 0;

  activitiesArray.forEach(city => {
    city.days?.forEach((day: any) => {
      if (!day.activities) return;

      ['morning', 'afternoon', 'night'].forEach(period => {
        const periodActivities = day.activities[period];

        if (!periodActivities) return;
        periodActivities.forEach((activity: any) => {
          totalActivities++;
          const activityId = activity?.activity?.id;
          const suggestions = suggestionsData[activityId];

          if (activityId && suggestions) {
            activity.activity.suggestionIA = suggestions;
            suggestionsAssigned++;
          }
        });
      });
    });
  });
}

addSuggestionsToParsedPeriods(activitiesArray: any[], suggestionsData: any): void {
  if (!activitiesArray || !suggestionsData) {
    console.error('❌ Faltan datos para procesar sugerencias');
    return;
  }

  let totalActivities = 0;
  let suggestionsAssigned = 0;


  activitiesArray.forEach((city, cityIndex) => {

    city.days?.forEach((day: any, dayIndex) => {
      // Opción 1: Usar parsedPeriods (nueva estructura)
      if (day.parsedPeriods && Array.isArray(day.parsedPeriods)) {

        day.parsedPeriods.forEach((parsedPeriod: any, periodIndex) => {

          if (parsedPeriod.activities && Array.isArray(parsedPeriod.activities)) {

            parsedPeriod.activities.forEach((activity: any, activityIndex) => {
              totalActivities++;

              // El id está dentro de activity.activity
              const activityId = activity?.activity?.id;

              if (activityId) {
                const suggestions = suggestionsData[activityId];

                if (suggestions) {
                  // Asignar sugerencias al nodo principal (activity)
                  activity.activity.suggestionIA = suggestions;
                  suggestionsAssigned++;
                } else {
                }
              } else {
              }
            });
          }
        });
      }
      // Opción 2: Mantener compatibilidad con estructura antigua (activities)
      else if (day.activities) {
        this.addSuggestionsToActivities([city], suggestionsData); // Reutilizar función anterior
      }
    });
  });

}

// Método para parsear los períodos


parsePeriods(data: any, preExtractedInsurances?: { activity: any; startDate: string; endDate: string }[]): void {
  // Función auxiliar para filtrar actividades válidas (con categoryName)
  const filterValidActivities = (activities: any[]) => {
    if (!Array.isArray(activities)) return [];
    return activities.filter(activity => activity?.activity?.categoryName);
  };

  // Extrae el hotelId real de un activity para agrupar hoteles del mismo edificio físico.
  // Se usa title (normalizado) como clave principal porque diferentes proveedores asignan
  // distintos idProduct/hotelCode al mismo hotel (ej: "525" en ZOCO vs "8473727" en RateHawk).
  const getHotelId = (activity: any): string => {
    try {
      const item = typeof activity.item === 'string'
        ? JSON.parse(activity.item)
        : activity.item;

      // title es el identificador más confiable cross-provider para el mismo hotel físico
      if (item?.title) return item.title.trim().toLowerCase();

      // Fallback: idProduct
      if (item?.idProduct) return String(item.idProduct);

      // Fallback: room.hotelCode
      if (item?.room?.hotelCode) return String(item.room.hotelCode);
    } catch (e) {
      // Si falla el parse, usar uid como fallback
    }

    // Fallback final: último segmento del uid
    const uid = activity.uid || '';
    return uid.includes('|') ? uid.split('|').pop()! : uid;
  };

  // Agrupa actividades de hotel del mismo hotel (mismo idProduct/hotelCode del item JSON)
  const groupHotelsByUid = (activities: any[]): any[] => {
    if (!activities || activities.length === 0) return activities;

    const hotelGroups = new Map<string, any[]>();

    // Primera pasada: identificar y agrupar hoteles por idProduct (parseado del item)
    activities.forEach(act => {
      if (act?.activity?.categoryName !== 'HOTELS') return;

      const hotelId = getHotelId(act.activity);

      if (!hotelGroups.has(hotelId)) {
        hotelGroups.set(hotelId, []);
      }
      hotelGroups.get(hotelId)!.push(act);
    });

    // Si no hay hoteles multi-habitación, devolver sin cambios
    const hasMultiRoom = Array.from(hotelGroups.values()).some(rooms => rooms.length > 1);
    if (!hasMultiRoom) return activities;

    // Segunda pasada: construir resultado reemplazando rooms individuales por entrada agrupada
    const seenHotelIds = new Set<string>();
    const result: any[] = [];

    activities.forEach(act => {
      if (act?.activity?.categoryName !== 'HOTELS') {
        result.push(act);
        return;
      }

      const hotelId = getHotelId(act.activity);

      if (seenHotelIds.has(hotelId)) return; // Saltar rooms duplicados
      seenHotelIds.add(hotelId);

      const rooms = hotelGroups.get(hotelId)!;

      if (rooms.length === 1) {
        result.push(rooms[0]);
      } else {
        // Agrupar: usar primera room como base, guardar todas en _groupedRooms
        result.push({
          ...rooms[0],
          activity: {
            ...rooms[0].activity,
            _isGroupedHotel: true,
            _groupedRooms: rooms.map(r => r.activity)
          }
        });
      }
    });

    return result;
  };

  // ========== PASO 1: Extraer insurances de todos los destinos ==========
  // Recolectar todos los insurance con sus fechas beginDateEndDate
  // Incluir seguros pre-extraídos de destinos solo-seguros (que ya fueron filtrados)
  const allInsurances: { activity: any; startDate: string; endDate: string }[] = [
    ...(preExtractedInsurances || [])
  ];

  // Primero extraer insurances de todos los destinos y días
  const dataWithoutInsurances = data.map((destination: any) => {
    const filteredDays = (destination.days || []).map((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return day;

      const filteredPeriods: any = {};
      ['morning', 'afternoon', 'night'].forEach(period => {
        if (!Array.isArray(periods[period])) {
          filteredPeriods[period] = [];
          return;
        }

        filteredPeriods[period] = periods[period].filter((act: any) => {
          if (act?.activity?.category_id === 10 || act?.activity?.categoryName === 'INSURANCE') {
            // Extraer fechas del insurance desde su item o form
            // Priorizar payload.dateBegin/dateEnd (fechas correctas sin timezone)
            // form.beginDateEndDate tiene timezone que puede dar fecha incorrecta
            // (ej: end "2026-06-07T03:59:59Z" es en realidad 06-06 en UTC-3)
            try {
              const item = typeof act.activity.item === 'string'
                ? JSON.parse(act.activity.item)
                : act.activity.item;

              const startDate = item?.payload?.dateBegin
                || act.activity.arrivalDate
                || (item?.form?.beginDateEndDate?.start
                  ? item.form.beginDateEndDate.start.split('T')[0]
                  : null);

              const endDate = item?.payload?.dateEnd
                || act.activity.departureDate
                || (item?.form?.beginDateEndDate?.end
                  ? item.form.beginDateEndDate.end.split('T')[0]
                  : null);

              if (startDate && endDate) {
                allInsurances.push({
                  activity: act.activity,
                  startDate,
                  endDate
                });
              }
            } catch (e) {
              // Fallback: usar arrivalDate/departureDate del activity
              if (act.activity.arrivalDate && act.activity.departureDate) {
                allInsurances.push({
                  activity: act.activity,
                  startDate: act.activity.arrivalDate,
                  endDate: act.activity.departureDate
                });
              }
            }
            return false; // Remover del flujo normal
          }
          return true;
        });
      });

      return {
        ...day,
        activities: filteredPeriods
      };
    });

    return {
      ...destination,
      days: filteredDays
    };
  });

  // ========== PASO 2: Eliminar destinos que SOLO tenían insurances ==========
  const dataCleaned = dataWithoutInsurances.filter((destination: any) => {
    const hasNonInsuranceActivities = (destination.days || []).some((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return false;
      return ['morning', 'afternoon', 'night'].some(p =>
        Array.isArray(periods[p]) && periods[p].length > 0
      );
    });
    // Mantener el destino si tiene actividades reales O si tiene días generados (fillMissingDays)
    const hasGeneratedDays = (destination.days || []).some((d: any) => d._isGenerated);
    return hasNonInsuranceActivities || hasGeneratedDays;
  });

  // ========== PASO 2.1: Insurance-only fallback — cuando todos los destinos eran solo-seguros
  // y fueron eliminados por el filtro de arriba, generamos un destino sintético para que
  // la plantilla de destiny-summary pueda renderizar la asistencia al viajero.
  // Este bloque solo se activa cuando NO hay destinos con actividades reales Y SÍ hay seguros.
  let dataWithSyntheticDestination = dataCleaned;
  if (dataCleaned.length === 0 && allInsurances.length > 0) {
    dataWithSyntheticDestination = this.buildSyntheticInsuranceDestination(allInsurances);
  }

  // ========== PASO 2.5: Generar días intermedios considerando también los rangos de los seguros ==========
  // Antes: fillMissingDays se llamaba ANTES de extraer seguros, así que los días
  // de los seguros no se generaban. Ahora con el refactor de Opción C, sabemos
  // TODOS los seguros desde el inicio, así que podemos pasárselos a fillMissingDays
  // para que extienda el rango de días a incluir las fechas de los seguros también.
  const dataWithFilledDays = this.fillMissingDays(dataWithSyntheticDestination, allInsurances);

  // ========== PASO 3: Procesar destinos limpios (misma lógica que antes) ==========
  this.summaryItinerary = dataWithFilledDays.map((destination: any) => {
    // Verificar si el destino tiene hotel (cualquier día con actividad de categoría HOTELS)
    const destinationHasHotel = (destination.days || []).some((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return false;
      return ['morning', 'afternoon', 'night'].some(p =>
        Array.isArray(periods[p]) && periods[p].some((a: any) =>
          a?.activity?.categoryName === 'HOTELS'
        )
      );
    });

    return {
      ...destination,
      destinationHasHotel,
      days: destination.days.map((day: any) => {
        const periods = day.activities;

        if (!periods || typeof periods !== 'object') {
          return {
            ...day,
            parsedPeriods: [],
            isFreeDay: true,
            destinationHasHotel: destinationHasHotel,
            _breakfastInfo: day._breakfastInfo || null,
            _isCheckoutDay: day._isCheckoutDay || false,
            _checkoutHotelInfo: day._checkoutHotelInfo || null
          };
        }

        // 1. Filtrar actividades válidas y luego agrupar hoteles por uid
        const modifiedPeriods = {
          morning: groupHotelsByUid(filterValidActivities(periods.morning || [])),
          afternoon: groupHotelsByUid(filterValidActivities(periods.afternoon || [])),
          night: groupHotelsByUid(filterValidActivities(periods.night || []))
        };

        // 2. Crear parsedPeriods con los mismos datos modificados
        // Los días intermedios (_isGenerated) con hotel clonado muestran "Mañana" en vez de "Tarde"
        const isGeneratedDay = day._isGenerated;
        const parsedPeriods = [
          {
            key: 'morning',
            label: 'Mañana',
            activities: modifiedPeriods.morning
          },
          {
            key: 'afternoon',
            label: isGeneratedDay ? 'Mañana' : 'Tarde',
            activities: modifiedPeriods.afternoon
          },
          {
            key: 'night',
            label: 'Noche',
            activities: modifiedPeriods.night
          }
        ].filter(period =>
          Array.isArray(period.activities) && period.activities.length > 0
        );

        return {
          ...day,
          // 3. Asignar LA MISMA ESTRUCTURA MODIFICADA a ambas propiedades
          activities: modifiedPeriods, // ← Esto modifica la estructura original
          parsedPeriods: parsedPeriods,
          isFreeDay: parsedPeriods.length === 0,
          destinationHasHotel: destinationHasHotel,
          // Preservar _breakfastInfo y _checkoutHotelInfo de días intermedios generados por fillMissingDays
          _breakfastInfo: day._breakfastInfo || null,
          _isCheckoutDay: day._isCheckoutDay || false,
          _checkoutHotelInfo: day._checkoutHotelInfo || null
        };
      })
    };

  });

  // ========== PASO 4: Inyectar insurances en los días correctos ==========
  this.injectInsurancesIntoDays(allInsurances);

  // ========== PASO 5: Inyectar rent-a-car checkout en el día de devolución ==========
  // El backend solo envía la actividad del rent-a-car en el día de pickup (arrivalDate).
  // Para mostrar la card con "Out" en el día de devolución (departureDate),
  // inyectamos una copia de la actividad en ese día, marcada con ckeckout: true.
  this.injectRentacarCheckoutDays();

  if(this.summaryItinerary && this.summaryItinerary.length > 0) {
    setTimeout(() => {
      this.appLoading = false;

      if(this.reloadItinerary) {

        this.reloadItinerary = false;
        // Cancelar safety timeout — el fetch real completó exitosamente
        if (this._loadingTimeout) {
          clearTimeout(this._loadingTimeout);
          this._loadingTimeout = null;
        }
      }
    }, 150);
  }
}

  /**
   * Inyecta los insurances extraídos en los días correctos del summaryItinerary.
   * - insuranceStartDate: se marca en el día correspondiente para mostrar "activa" ANTES del primer label
   * - insuranceEndDate: se marca en el día correspondiente para mostrar "finalizo" DESPUÉS del checkout
   */
  private injectInsurancesIntoDays(insurances: { activity: any; startDate: string; endDate: string }[]): void {
    if (!insurances || insurances.length === 0) return;
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    // Normalizar fechas de insurance a YYYY-MM-DD
    const normalizedInsurances = insurances.map(ins => ({
      ...ins,
      startDate: this.normalizeDateToYYYYMMDD(ins.startDate),
      endDate: this.normalizeDateToYYYYMMDD(ins.endDate)
    }));

    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      if (days.length === 0) return;

      days.forEach((day: any) => {
        if (!day.full_date) return;

        // Buscar insurances cuyo startDate coincide con este día
        const activeInsurances = normalizedInsurances.filter(
          ins => ins.startDate === day.full_date
        );

        // Buscar insurances cuyo endDate coincide con este día
        const endedInsurances = normalizedInsurances.filter(
          ins => ins.endDate === day.full_date
        );

        // Crear arrays separados: _insurancesActive (startDate) y _insurancesEnded (endDate)
        if (activeInsurances.length > 0) {
          day._insurancesActive = activeInsurances.map(ins => ({
            ...ins.activity,
            item: JSON.parse(ins.activity.item),
            _status: 'active',
            _title: ins.activity.item?.title || ins.activity.title || '',
            _image: ins.activity.item?.images?.[0] || '',
            _startDate: ins.startDate,
            _endDate: ins.endDate
          }));
          // Inicializar estado del collapsible (cerrado por defecto)
          day._insurancesExpanded = false;
        }

        if (endedInsurances.length > 0) {
          day._insurancesEnded = endedInsurances.map(ins => ({
            ...ins.activity,
            item: JSON.parse(ins.activity.item),
            _status: 'ended',
            _title: ins.activity.item?.title || ins.activity.title || '',
            _image: ins.activity.item?.images?.[0] || '',
            _startDate: ins.startDate,
            _endDate: ins.endDate
          }));
          // Inicializar estado del collapsible de ended (cerrado por defecto)
          day._insurancesEndedExpanded = false;
        }
      });
    });
  }

  /**
   * Inyecta actividades de rent-a-car en el día de devolución (departureDate).
   * El backend solo envía la actividad en el día de pickup (arrivalDate).
   * Este método busca rent-a-cars y clona la actividad en el día de departureDate,
   * marcándola con ckeckout: true para que el template muestre "Out" en rojo.
   */
  private injectRentacarCheckoutDays(): void {
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    // Recolectar todos los rent-a-cars con su departureDate y destinationIata
    const rentacarCheckouts: { activity: any; departureDate: string; destinationIata: string }[] = [];

    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      days.forEach((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;

        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            if (act?.activity?.categoryName !== 'RENT-A-CAR' && act?.activity?.category_id !== 2) return;

            try {
              const item = typeof act.activity.item === 'string'
                ? JSON.parse(act.activity.item)
                : act.activity.item;

              // departureDate del item parseado es la fecha de devolución
              const departureDate = item?.departureDate
                ? this.normalizeDateToYYYYMMDD(item.departureDate)
                : null;

              if (departureDate) {
                rentacarCheckouts.push({
                  activity: act.activity,
                  departureDate,
                  destinationIata: destination.iata_code
                });
              }
            } catch (e) {
              // Si falla el parse, intentar con departureDate directo del activity
              if (act.activity.departureDate) {
                rentacarCheckouts.push({
                  activity: act.activity,
                  departureDate: this.normalizeDateToYYYYMMDD(act.activity.departureDate),
                  destinationIata: destination.iata_code
                });
              }
            }
          });
        });
      });
    });

    if (rentacarCheckouts.length === 0) return;

    // Inyectar en los días correspondientes
    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      if (days.length === 0) return;

      days.forEach((day: any) => {
        if (!day.full_date) return;

        // Buscar rent-a-cars cuyo departureDate coincide con este día Y cuyo destino es el mismo
        const matchingRentacars = rentacarCheckouts.filter(
          rc => rc.departureDate === day.full_date && rc.destinationIata === destination.iata_code
        );

        if (matchingRentacars.length === 0) return;

        // Verificar si ya existe una actividad de rent-a-car en este día (evitar duplicados)
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;

        const existingRentacarIds = new Set<number>();
        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            if (act?.activity?.categoryName === 'RENT-A-CAR' || act?.activity?.category_id === 2) {
              existingRentacarIds.add(act.activity.id);
            }
          });
        });

        matchingRentacars.forEach(rc => {
          // Evitar duplicados: si el rent-a-car ya está en este día, no inyectar
          if (existingRentacarIds.has(rc.activity.id)) return;

          // Crear wrapper con ckeckout: true para que el template muestre "Out"
          const checkoutActivity = {
            activity: {
              ...rc.activity,
              ckeckout: true
            }
          };

          // Agregar al período morning (primer período visible del día)
          if (!Array.isArray(day.activities.morning)) {
            day.activities.morning = [];
          }
          day.activities.morning.push(checkoutActivity);

          // Actualizar parsedPeriods si ya fue procesado
          if (day.parsedPeriods && Array.isArray(day.parsedPeriods)) {
            const morningPeriod = day.parsedPeriods.find((p: any) => p.key === 'morning');
            if (morningPeriod) {
              if (!Array.isArray(morningPeriod.activities)) {
                morningPeriod.activities = [];
              }
              morningPeriod.activities.push(checkoutActivity);
            } else {
              // Crear morning period si no existe
              day.parsedPeriods.unshift({
                key: 'morning',
                label: 'Mañana',
                activities: [checkoutActivity]
              });
            }
          }

          // Ya no es un día libre
          day.isFreeDay = false;

          existingRentacarIds.add(rc.activity.id);
        });
      });
    });
  }

  /**
   * Construye un destino sintético para itinerarios que contienen SOLO seguros de asistencia
   * al viajero (sin hoteles, traslados, tours, etc.).
   *
   * Cuando todos los destinos fueron eliminados por el filtro de insurance-only en
   * parsePeriods (paso 2), este método genera un destino virtual con días creados a partir
   * del rango de fechas de cada seguro. Los días resultantes reciben la estructura estándar
   * (isFreeDay: true, activities vacías) para que injectInsurancesIntoDays pueda anotar
   * _insurancesActive / _insurancesEnded correctamente y la plantilla existente de
   * destiny-summary los renderice sin cambios.
   *
   * @param insurances - Lista de seguros extraídos del backend.
   * @returns Un arreglo con un único destino sintético, o [] si no hay seguros.
   */
  private buildSyntheticInsuranceDestination(insurances: { activity: any; startDate: string; endDate: string }[]): any[] {
    if (!insurances || insurances.length === 0) return [];

    // Agrupar seguros por iata_code del destino para crear un destino por ciudad
    const byIata = new Map<string, typeof insurances>();
    insurances.forEach(ins => {
      const iata = ins.activity.destination_iata
        || ins.activity.destination?.iata_code
        || 'INSURANCE';
      if (!byIata.has(iata)) {
        byIata.set(iata, []);
      }
      byIata.get(iata)!.push(ins);
    });

    const syntheticDestinations: any[] = [];

    byIata.forEach((igroup, iata) => {
      // city_name: usar el título del primer seguro disponible, o el literal fijo
      const firstInsurance = igroup[0];
      let cityName = 'Asistencia al viajero';
      try {
        const item = typeof firstInsurance.activity.item === 'string'
          ? JSON.parse(firstInsurance.activity.item)
          : firstInsurance.activity.item;
        if (item?.title) {
          cityName = item.title;
        } else if (item?.payload?.name) {
          cityName = item.payload.name;
        }
      } catch (e) {
        // Mantener el literal por defecto
      }

      // Recopilar todos los días únicos del rango de los seguros
      const allDates = new Set<string>();
      igroup.forEach(ins => {
        let current = this.normalizeDateToYYYYMMDD(ins.startDate);
        const end = this.normalizeDateToYYYYMMDD(ins.endDate);
        while (current <= end) {
          allDates.add(current);
          current = this.addDaysToDate(current, 1);
        }
      });

      const sortedDates = Array.from(allDates).sort();
      const syntheticDays: any[] = [];

      sortedDates.forEach((dateStr, index) => {
        // Determinar para cada seguro si este día es startDate (activa) o endDate (finalizó)
        const dayInsurancesActive: any[] = [];
        const dayInsurancesEnded: any[] = [];

        igroup.forEach(ins => {
          const start = this.normalizeDateToYYYYMMDD(ins.startDate);
          const end = this.normalizeDateToYYYYMMDD(ins.endDate);
          if (dateStr === start) {
            dayInsurancesActive.push(ins);
          }
          if (dateStr === end) {
            dayInsurancesEnded.push(ins);
          }
        });

        syntheticDays.push({
          full_date: dateStr,
          date: this.formatDateShort(dateStr),
          day_title: `Dia ${index + 1} - Asistencia al viajero`,
          has_airport_transfer: false,
          activities: { morning: [], afternoon: [], night: [] },
          parsedPeriods: [],
          isFreeDay: true,
          _insurancesActive: dayInsurancesActive.length > 0 ? dayInsurancesActive : undefined,
          _insurancesEnded: dayInsurancesEnded.length > 0 ? dayInsurancesEnded : undefined,
          _insurancesExpanded: false,
          _insurancesEndedExpanded: false
        });
      });

      syntheticDestinations.push({
        iata_code: iata,
        city_name: cityName,
        days: syntheticDays,
        _isSyntheticInsuranceDestination: true
      });
    });

    return syntheticDestinations;
  }

  /**
   * Normaliza una fecha a formato YYYY-MM-DD.
   * Maneja tanto fechas ISO (2026-06-07T04:00:00.000Z) como simples (2026-06-07).
   */
  private normalizeDateToYYYYMMDD(dateStr: string): string {
    if (!dateStr) return '';
    return dateStr.split('T')[0];
  }

   /**
   * Muestra el loading state del itinerary.
   * NO hace fetch prematuro — el fetch real lo hace el subscriber de activeItinerary
   * cuando el backend confirma la operación (add/delete/update) via consultActiveItinerary.
   *
   * Flujo: child emite reloadSummaryItinerary → este método muestra loading
   * → backend completa POST → consultActiveItinerary → sendMessageActiveItinerary
   * → activeItinerary emite → _initData subscriber → getItinerarySummary()
   * → parsePeriods() → reloadItinerary = false (loading se oculta).
   *
   * Safety timeout: si después de 10s el backend no respondió, oculta el loading
   * para no dejarlo colgado indefinidamente.
   */
   private _loadingTimeout: any = null;

   reloadSummaryItineraryFx(): void {
   this.reloadItinerary = true;
   this.summaryItinerary = [];
   this.scrollToTop();

   // Safety: si el backend no responde en 10s, ocultar loading
   if (this._loadingTimeout) {
     clearTimeout(this._loadingTimeout);
   }
   this._loadingTimeout = setTimeout(() => {
     if (this.reloadItinerary) {
       console.warn('reloadSummaryItineraryFx: safety timeout — backend no respondió en 10s');
       this.getItinerarySummary();
     }
   }, 10000);
 }

private scrollToTop(): void {
  // Opción 1: Smooth scroll al top
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // 'auto' para scroll instantáneo
  });

}

/**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

}
